import { FolderIcon, Header, Paragraph, ResponsiveButton } from "@datagame/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ManageFoldersModal } from "../../../shared/modals/ManageFoldersModal";
import { type Folder, FoldersList } from "./FoldersList";

import styles from "./FoldersSection.module.scss";

export interface FoldersSectionProps {
  selectedFolder?: Folder;
  setSelectedFolder: (folder: Folder) => void;
  groupedFolders: Folder[];
}

export const FoldersSection = ({ selectedFolder, setSelectedFolder, groupedFolders }: FoldersSectionProps) => {
  const { t } = useTranslation();

  const [isManageFoldersModalOpen, setIsManageFoldersModalOpen] = useState(false);

  return (
    <div className={styles.foldersContainer}>
      <div className={styles.folderHeaderWrapper}>
        <div className={styles.folderHeader}>
          <Header variant="h6" className={styles.header}>
            {t("projects:folderSection.title")}
          </Header>
          <Paragraph size="small" color="secondary">
            {t("projects:folderSection.description")}
          </Paragraph>
        </div>
        <ResponsiveButton
          onClick={() => setIsManageFoldersModalOpen(true)}
          size="medium"
          className={styles.folderButton}
          kind="outline"
          iconSide="left"
          icon={<FolderIcon />}
        >
          {t("projects:folderSection.manageFolders")}
        </ResponsiveButton>
      </div>

      <div>
        <FoldersList groupedFolders={groupedFolders} selected={selectedFolder} setSelected={setSelectedFolder} />
      </div>
      {isManageFoldersModalOpen && (
        <ManageFoldersModal onClose={() => setIsManageFoldersModalOpen(false)} folders={groupedFolders} />
      )}
    </div>
  );
};
